module.exports = __webpack_public_path__ + "img/rx7-75.9a460445.png";